















import Vue from "vue";
import ScrollReveal from "scrollreveal";
import PublicationArticle from "@/components/publications-view/publication-article/PublicationArticle.vue";
import HeaderImg from "@/components/shared/header-img/HeaderImg.vue";
import { getPublications } from "@/resources/content/publications.ts";
import { scrollConfig } from "@/resources/animations/configs.ts";

export default Vue.extend({
  name: "Publications",
  components: {
    PublicationArticle,
    HeaderImg,
  },
  data() {
    return {
      publications: <any>[],
      publicationsHeaderImg: {
        path: "publications",
        image: "",
        imageAlt: "publications top img",
      },
    };
  },
  created() {
    this.publications = getPublications();
    this.publicationsHeaderContent();
  },
  mounted() {
    window.scrollTo(0, 0);
    this.setRevealAnimation();

    window.addEventListener("resize", () => this.publicationsHeaderContent());
  },
  beforeDestroy() {
    window.removeEventListener("resize", () =>
      this.publicationsHeaderContent()
    );
  },
  methods: {
    setRevealAnimation() {
      Object.entries(this.publications).forEach((_, index) => {
        ScrollReveal().reveal(`.publication-${index}`, scrollConfig);
      });
    },
    publicationsHeaderContent() {
      const width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      const desktopViewport = width > 599;
      this.publicationsHeaderImg = {
        ...this.publicationsHeaderImg,
        image: desktopViewport
          ? "desktop_publications_top_img.jpg"
          : "mobile_publications_img.jpg",
      };
    },
  },
});
